import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { notifier } from 'components/Toaster';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import useGetLessonIssues from 'hooks/API/GET/useGetLessonIssues';
import useLessonIssueStatus from 'hooks/API/POST/useLessonIssueStatus';

const STATUS_LABELS = {
  open: 'Open',
  resolved: 'Resolved',
  dismissed: 'Dismissed',
};

const ISSUE_TYPE_LABELS = {
  incorrect_content: 'Incorrect content',
  broken_content: 'Broken content',
  typo: 'Typo',
  missing_content: 'Missing content',
  other: 'Other',
};

function LessonIssues() {
  const history = useHistory();
  const queryClient = useQueryClient();

  const { data, isLoading } = useGetLessonIssues({ enabled: true });
  const issues = data?.data?.data?.result ?? [];

  const { mutate: updateStatus } = useLessonIssueStatus();

  const handleStatus = (issueId, status) => {
    updateStatus(
      { issueId, status },
      {
        onSuccess: () => {
          notifier.success(`Issue marked as ${status}`);
          queryClient.invalidateQueries('lesson-issues');
        },
        onError: () => notifier.error('Failed to update status'),
      }
    );
  };

  const handleRowClick = (issue) => {
    history.push(`/manage/lesson-issues/${issue._id}`, { issue });
  };

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={() => history.goBack()}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs current="Lesson Issues" />
          </div>

          {isLoading ? (
            <p>Loading...</p>
          ) : issues.length === 0 ? (
            <p className="text-center" style={{ padding: '40px 0', color: '#888' }}>
              No issues reported yet.
            </p>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>Course</th>
                    <th>Chapter</th>
                    <th>Lesson</th>
                    <th>Issue Type</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {issues.map((issue) => (
                    <tr
                      key={issue._id}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleRowClick(issue)}
                    >
                      <td>{issue.user?.name || issue.user?.email || '—'}</td>
                      <td>{issue.course?.courseName || '—'}</td>
                      <td>{issue.chapter?.name || '—'}</td>
                      <td>{issue.topic?.name || '—'}</td>
                      <td>{ISSUE_TYPE_LABELS[issue.issueType] || issue.issueType}</td>
                      <td>
                        <span
                          className={`badge badge-${
                            issue.status === 'open'
                              ? 'warning'
                              : issue.status === 'resolved'
                              ? 'success'
                              : 'secondary'
                          }`}
                        >
                          {STATUS_LABELS[issue.status]}
                        </span>
                      </td>
                      <td>{new Date(issue.createdAt).toLocaleDateString()}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        {issue.status === 'open' && (
                          <>
                            <button
                              className="btn btn-sm btn-success"
                              style={{ marginRight: 6 }}
                              onClick={() => handleStatus(issue._id, 'resolved')}
                            >
                              Resolve
                            </button>
                            <button
                              className="btn btn-sm btn-secondary"
                              onClick={() => handleStatus(issue._id, 'dismissed')}
                            >
                              Dismiss
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LessonIssues;
